import { LocaleTranslation } from "../types";
import { americanEnglish } from "./en-us";
import { canadianFrench } from "./fr-ca";
import { americanSpanish } from "./es-us";
import { britishEnglish } from "src/i18n/translations/en-gb";
import { german } from "src/i18n/translations/de-de";
import { dutch } from "src/i18n/translations/nl-nl";
import { frenchFrance } from "src/i18n/translations/fr-fr";
import { SUPPORTED_LOCALE } from "src/i18n/constants";

const translations: Record<SUPPORTED_LOCALE, LocaleTranslation> = {
  [SUPPORTED_LOCALE.EN_US]: americanEnglish,
  [SUPPORTED_LOCALE.FR_CA]: canadianFrench,
  [SUPPORTED_LOCALE.ES_US]: americanSpanish,
  [SUPPORTED_LOCALE.EN_GB]: britishEnglish,
  [SUPPORTED_LOCALE.DE_DE]: german,
  [SUPPORTED_LOCALE.NL_NL]: dutch,
  [SUPPORTED_LOCALE.FR_FR]: frenchFrance,
  // Mexico uses Spanish (es-US) translations; dedicated es-MX file can be added later if regional differences are needed
  [SUPPORTED_LOCALE.ES_MX]: americanSpanish,
  // India falls back to English until native-reviewed Hindi (hi-IN) translations are available
  [SUPPORTED_LOCALE.HI_IN]: americanEnglish,
};

export default translations;
